import React from 'react';
import { GraduationCap, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-slate-200 py-12 px-4" data-id="element-165">
      <div className="max-w-4xl mx-auto text-center" data-id="element-166">
        <div className="inline-flex items-center gap-2 mb-3" data-id="element-167">
          <GraduationCap className="w-5 h-5 text-primary" data-id="element-168" />
          <span className="font-space-grotesk font-extrabold text-slate-900 text-lg md:text-xl tracking-tight" data-id="element-169">
            COMPRA DIGITAL YA™
          </span>
        </div>

        <p className="text-sm md:text-base text-slate-700 font-bold mb-2" data-id="element-170">
          El sistema N°1 para docentes de Primer Grado en Argentina.
        </p>
        <p className="text-xs md:text-sm text-slate-500 max-w-2xl mx-auto mb-8 leading-relaxed font-medium" data-id="element-171">
          Porque enseñar no debería costarte todos los fines de semana del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-6 text-xs md:text-sm text-slate-600 mb-8 font-medium" data-id="element-172">
          <a href="mailto:compradigitalyaa@gmail.com" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-173">
            <Mail className="w-3.5 h-3.5" data-id="element-174" />
            compradigitalyaa@gmail.com
          </a>
          <span className="hidden sm:inline text-slate-300" data-id="element-175">·</span>
          <a href="https://compradigitalya.com" className="flex items-center gap-1.5 hover:text-primary transition-colors" data-id="element-176">
            <Globe className="w-3.5 h-3.5" data-id="element-177" />
            compradigitalya.com
          </a>
        </div>

        <div className="pt-6 border-t border-slate-100 text-[11px] md:text-xs text-slate-400 font-medium" data-id="element-178">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}